import React, { useCallback, useState } from 'react';
import Chip from '@material-ui/core/Chip';

const matrixJSAPI = (key) => {
  try {
    return new window.Squiz_Matrix_API({ key });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
};

const FacilityTag = ({
  apiKey,
  parentId,
  assetType,
  setLive,
  numberOfSubId,
  relatedFacilitiesId,
}) => {
  const [state, setState] = useState({
    input: '',
    chipData: [],
    loading: false,
  });

  const js_api = matrixJSAPI(apiKey);

  const matrixCreateAsset = async (name) =>
    await js_api.createAsset({
      parent_id: parentId,
      type_code: assetType,
      asset_name: name,
      link_type: 2,
    });

  const setAssetToLive = async (asset) =>
    await js_api.setAssetStatus({
      asset_id: asset.id,
      status: 16,
      cascade: 1,
    });

  const setAssetToArchive = async (asset) =>
    await js_api.setAssetStatus({
      asset_id: asset.id,
      status: 1,
      cascade: 1,
    });

  const handleInput = useCallback(
    ({ target }) => {
      setState((prevState) => ({ ...prevState, input: target.value }));
    },
    [setState]
  );

  const handleKeyDown = async (event) => {
    if (event.key !== 'Enter') return;

    event.preventDefault();

    if (
      state.input !== '' &&
      !state.chipData.some((el) => el.name === state.input)
    ) {
      try {
        setState((prevState) => ({
          ...prevState,
          loading: true,
        }));

        const asset = await matrixCreateAsset(state.input);
        setLive && (await setAssetToLive(asset));

        setState((prevState) => ({
          ...prevState,
          chipData: [...prevState.chipData, { id: asset.id, name: asset.name }],
        }));
      } catch (e) {
        setState((prevState) => ({
          ...prevState,
          loading: false,
        }));

        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        setState((prevState) => ({
          ...prevState,
          loading: false,
          input: '',
        }));
      }
    }
  };

  const handleDelete = (chipToDelete) => async () => {
    try {
      await setAssetToArchive(chipToDelete);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      setState((prevState) => ({
        ...prevState,
        chipData: prevState.chipData.filter(
          (chip) => chip.id !== chipToDelete.id
        ),
      }));
    }
  };

  const displayTags = state.chipData.map((data, index) => (
    <li key={`${data.id}--${index}`} className="facility__item">
      <Chip
        className="facility__element"
        label={data.name}
        onDelete={handleDelete(data)}
      />
    </li>
  ));

  return (
    <div className="user-registration__field user-registration__input sq-form-question-answer">
      <label htmlFor="facility_input" className="user-registration__label">
        Add facility
      </label>
      <input
        autoComplete="off"
        type="text"
        name="facility_input"
        value={state.input}
        onChange={handleInput}
        onKeyDown={handleKeyDown}
        placeholder={`Click 'Enter' to add facility.`}
        size="30"
        className="sq-form-field"
        id="facility_input"
        disabled={state.chipData.length === 10 || state.loading}
      />
      <input
        type="hidden"
        name={`metadata_field_text_${numberOfSubId}_value`}
        value={state.chipData.length}
        id={`metadata_field_text_${numberOfSubId}_value`}
      ></input>
      <input
        type="hidden"
        name={`metadata_field_text_${relatedFacilitiesId}_value`}
        value={state.chipData.map((el) => el.id).join(';')}
        id={`metadata_field_text_${relatedFacilitiesId}_value`}
      ></input>

      <span className="facility__info">
        You can add up to 10 facilities ({state.chipData.length}/10).
      </span>
      {state.loading ? <span className="facility__info">Adding...</span> : null}
      <ul className="facility__list">{displayTags}</ul>
    </div>
  );
};

export default React.memo(FacilityTag);
